<template>
  <Style>
    :root { 
    --calendar-background-color: {{ background }};
    --calendar-box-background: {{ bookedSessionBox.background }};
    --calendar-box-border-width: {{ bookedSessionBox.borderWidth }};
    --calendar-box-border-color: {{ bookedSessionBox.borderColor }};
    --calendar-box-border-hover-color: {{ bookedSessionBox.borderHoverColor }};
    --calendar-box-border-radius: {{ bookedSessionBox.borderRadius }};
    --calendar-box-name-color: {{ bookedSessionBox.nameColor }};
    --calendar-box-name-weight: {{ bookedSessionBox.nameFontWeight }}; 
    --calendar-box-time-color: {{ bookedSessionBox.timeColor }};
    --calendar-box-time-background: {{ bookedSessionBox.timeBackground }}; 
    --calendar-box-time-border-width: {{ bookedSessionBox.timeBorderWidth }};
    --calendar-box-time-border-color: {{ bookedSessionBox.timeBorderColor }};
    --calendar-box-time-border-radius: {{ bookedSessionBox.timeBorderRadius }};
    --calendar-box-cancel-color: {{ bookedSessionBox.cancelColor }};
    --calendar-box-cancel-color-hover: {{ bookedSessionBox.cancelColorHover }};
    --calendar-box-cancel-background-hover: {{ bookedSessionBox.cancelBackgroundHover }};
    }
  </Style>
</template>

<script>
/* Always render the THEME styles first. That forms the BASE.
And then on top of the theme styles, render every other customization. 
There are also default styles, meaning if a user doesn't have a style, the default is loaded instead in all cases. */
import { mapState } from "vuex";
import Style from "./Style";

export default {
  name: "CustomStyles",
  components: {
    Style,
  },
  computed: {
    ...mapState({
      styles: (state) => state.style.styles,
    }),
    background() {
      return this.styles.background;
    },
    bookedSessionBox() {
      return this.styles.bookedSessionBox;
    },
  },
};
</script>